import api from '../api'

import { loadEntity } from 'lib/actionHelpers'

export default async function loadPublicOrganizationsWithActivity(){
  return loadEntity.call(this, {
    reload: false,
    entityKey: 'publicOrganizationsWithActivity',
    request: () =>
      api.getPublicOrganizationsWithActivity().then(({ organizations }) => {
        this.takeAction('organization.addOrganizationsToAppState', organizations)

        const activeOrganizations = organizations.filter(o => o.is_active)
        const inactiveOrganizations = organizations.filter(o => !o.is_active)

        return {
          activeOrganizations: activeOrganizations,
          inactiveOrganizations: inactiveOrganizations,
          allOrganizations: organizations
        }
      })
    ,
  })
}
